const options = {
  5: "bg-zinc-500/5",
  10: "bg-zinc-500/10",
  25: "bg-zinc-500/25",
  50: "bg-zinc-500/50",
  75: "bg-zinc-500/75",
  90: "bg-zinc-500/90",
  100: "bg-zinc-500",
};

const from = {
  5: "from-zinc-500/5",
  10: "from-zinc-500/10",
  25: "from-zinc-500/25",
  50: "from-zinc-500/50",
  75: "from-zinc-500/75",
  90: "from-zinc-500/90",
  100: "from-zinc-500",
};

export default function getBackgroundZinc500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
